import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import breakpointTokens from '@lmig/lmds-tokens/dist/json/core/breakpoint.json';
import { useMediaQuery } from './useMediaQuery';
export function useMinBreakpoint(breakpoint) {
  var mediaQuery = '';
  if (breakpoint === 'always') {
    mediaQuery = '(min-width: 0px)';
  } else if (breakpoint === 'never') {
    mediaQuery = '(max-width: 0px)';
  } else {
    var minWidth = breakpointTokens.lmig.breakpoint[breakpoint].raw.toString();
    mediaQuery = "(min-width: ".concat(minWidth, "px)");
  }
  return useMediaQuery(mediaQuery);
}